<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.infoDiv {
  width: 50%;
  height: 40px;
  border: 1px solid #bb87f370;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;
}
.moneyDiv {
  width: 100%;
  height: 40px;
  background-color: #bb87f313;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;
  margin: 20px 0;
}
.el-checkbox__inner {
  width: 18px;
  height: 18px;
}
// /deep/.el-input__inner {
//     background: #F8F9FC;
//     font-size: 12px;
//     font-weight: 400;
//     color: #BCBCBC;
//     line-height: 17px;
//     font-family: PingFangSC-Regular, PingFang SC;
//     border-radius: 4px;
// }
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">运营商结算</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营商名称</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.dealNo"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
                @change="dealChange"
              >
                <el-option v-for="item in dea1erList" :label="item.dealName" :value="item.dealNo" :key="item.dealNo"></el-option>
                
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">站点名称</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                filterable
                remote
                v-model="queryInfo.stationNo"
                clearable
                @focus="getSiteAll"
                @keyup.enter.native="getListData(pagination, true)"
              >
              <el-option v-for="item in stationList" :label="item.stationName" :value="item.stationNo" :key="item.stationNo"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">月度结算记录</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                value-format="yyyy-MM"
                v-model="queryInfo.chargeMonth"
                :picker-options="pickerOptions"
                type="month"
                placeholder="请选择自然月"
                size="small"
                style="width: 100%"
              >
              </el-date-picker>
            </div>
          </div>
          <div
            class="list-query-child-div"
            style="width:500px;display: flex;justify-content: space-around;align-items: center;"
          >
            <div class="query-title-div">订单类型</div>
            <div class="query-inputs-div flex-1">
              <el-checkbox-group
                v-model="checkedCities"
                style="width:380px;"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  size="medium"
                  v-for="city in cities"
                  :label="city.value"
                  :key="city.value"
                  >{{ city.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜索
          </button>
          <button
            class="common-bg-button"
            @click="handelExport"
          >
          导出
          </button>
        </template>
        <template slot="actions">
          <!-- <button class="common-empty-button" @click="reset()">重 置</button> -->
        </template>
      </ZD-list-querys>
      <!-- <div class="infoDiv">
        <p>公司名称：</p>
        <p>公司地址：</p>
        <p>联系人：</p>
        <p>联系电话：</p>
      </div> -->
      <div class="moneyDiv">
        <p>订单数：{{ infoList.orderCount }}</p>
        <p>充电时长：{{ infoList.lastingTime }}</p>
        <p>充电电量（度）：{{ infoList.totalChargeCount }}</p>
        <p>实收金额（元）：{{ infoList.tActFee }}</p>
        <p>产生电费（元）：{{ infoList.actElecFee }}</p>
        <p>实收电费（元）：{{ infoList.actElecFee }}</p>
        <p>服务费用（元）：{{ infoList.servFee }}</p>
      </div>
      
      <div class="page-action-btns flex"></div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
         
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
    <!-- 表格 -->
  </div>
</template>

<script>
import axios from "axios";
import pageConfig from "./page-config";
export default {
  data() {
    return {
      checkedCities: ['02','01','09','04','06'],
      cities: [
        {
          label: "app",
          value: "02",
        },
        {
          label: "卡",
          value: "01",
        },
        {
          label: "小程序",
          value: "09",
        },
        {
          label: "平台",
          value: "04",
        },
        {
          label: "联联",
          value: "06",
        },
      ],
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      dea1erList:[],
      stationList:[],
      pagination: pageConfig.pagination,
      queryInfo: {
        
      },
      source:[],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      searchTime: [], //选择时间
      infoList: {},
      pickerOptions: {
        //修改el-date-picker的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
   
   
    handleCheckedCitiesChange(value) {
        this.queryInfo.source = value.join(',')
    console.log(value);
    
    },
    init() {
        this.queryInfo.source = this.checkedCities.join(',')
      // this.getListData(this.pagination, true);
    },
    //秒数转化为时分秒
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取余，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取余的分，获取分钟除以60取余的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + parseInt(secondTime) + "秒";

      if (minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result;
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result;
      }
      console.log("result", result);
      return result;
    },
    // 获取运营
    getDealer(){
      
        let _ = this
        let obj = {
          custPhone: localStorage.getItem('userPhone')?localStorage.getItem('userPhone'):''
        }
        _.$H
        .post(_, _.$A.operatorSettlement.getDealList,obj)
        .then((res) => {
          _.dea1erList = res.data.data.map(item=>{
            return {
                dealName:item.dealName,
                dealNo:item.dealNo,
            }
          })
        });
    },
    // 运营切换
    dealChange(val){
        let _ = this
       
        _.$H
        .post(_, _.$A.operatorSettlement.list,{dealNo:val})
        .then((res) => {
          _.stationList = res.data.data.map(item=>{
            return {
                stationName:item.stationName,
                stationNo:item.stationNo,
            }
          })
        });
    },
    getSiteAll() {
      if (this.queryInfo.dealNo == "" || this.queryInfo.dealNo == null) {
        this.stationList = [];
        return this.$message.error("请选择运营商!");
      } 
    },
   
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      if (_.queryInfo.chargeMonth == null || _.queryInfo.chargeMonth=='') {
        return _.$message.error("请选择月份!");
      } 
      if (_.queryInfo.dealNo == null || _.queryInfo.dealNo=='') {
        return _.$message.error("请选择运营商!");
      } 
      if (_.queryInfo.stationNo == null || _.queryInfo.stationNo=='') {
        return _.$message.error("请选择站点!");
      } 
    
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H
        .post(_, _.$A.operatorSettlement.getDtoListSummary, _.queryInfo)
        .then((res) => {
          _.infoList.orderCount = res.data.data.orderCount;
          _.infoList.lastingTime = _.formatSeconds(res.data.data.lastingTime);
          _.infoList.totalChargeCount = res.data.data.totalChargeCount;
          _.infoList.tActFee = res.data.data.tActFee;
          _.infoList.actElecFee = res.data.data.actElecFee;
          _.infoList.servFee = res.data.data.servFee;
          _.tableData = res.data.data.list || [];
          _.tableData.forEach(item=>{
            item.chargSeconds = item.chargSeconds?_.formatSeconds(item.chargSeconds):'';
          })
         
        _.pagination.total = res.data.data.totalItems || 0;
      
          _.$U.hideLoading(_);
        });
    },
    handelExport(){
      let _ = this
      
      _.$H
              .post(_, _.$A.operatorSettlement.dtoListSummaryExport,_.queryInfo)
              .then((res) => {
                console.log(res);
                let  content = res.data.data.base64
            // 使用atob方法解码base64
            var raw = window.atob(content);
            // 创建一个存储解码后数据的数组
            var uInt8Array = new Uint8Array(raw.length);
            // blob只能接收二进制编码，需要讲base64转为二进制再塞进去
            for (var i = 0; i < raw.length; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            // 这里给了一个返回值，在别的方法掉用传入base64编码就可以得到转化后的blob
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], { type: 'application/vnd.ms-excel' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            //设置下载的Excel表名
            link.setAttribute('download', `${res.data.data.fileName}`)  //要有文件名后缀，如.xslx
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            
              //  _.downloadBase64File(res.data.data.base64,res.data.data.fileName)
              });
             
    },
    //选择结束时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0];
        this.queryInfo.dtTo = val[1];
      } else {
        delete this.queryInfo.dtFrom;
        delete this.queryInfo.dtTo;
      }
    },
   
  
  },
  mounted() {
    this.init();
    this.getDealer()
  },
};
</script>
